/**
 * ทางลัดโปรแกรม & URL บริษัท — สำหรับเมนู "/links"
 * แก้ลิสต์นี้แล้ว build ใหม่ (ไม่ได้ดึงจาก API)
 *
 * TODO: แทน [ใส่ URL] ด้วย URL จริง / เพิ่ม-ลบรายการได้ตามต้องการ
 */
export interface LinkGroup {
  title: string
  items: { label: string; url: string; note?: string }[]
}

export const LINK_GROUPS: LinkGroup[] = [
  {
    title: 'โปรแกรมหลัก',
    items: [
      { label: 'POS ออนไลน์', url: 'https://pos.pwcmall.in.th/auth' },
      { label: 'NF', url: 'https://probiz.pwcmall.in.th/ui#name=login' },
      { label: 'Probiz Report', url: 'https://probiz-report.pwcmall.in.th/news' },
    ],
  },
  {
    title: 'Inventory',
    items: [
      { label: 'หน้าหลัก', url: 'https://inventory.pwcmall.in.th/list' },
      // { label: 'เบิกใช้ภายในร้าน (UI)', url: 'https://inventory.pwcmall.in.th/form?type=internal&pick_type=out&journal_id=36' },
      // { label: 'เบิกเพื่อทำลาย (DM)', url: 'https://inventory.pwcmall.in.th/form?type=internal&pick_type=out&journal_id=186' },
      // { label: 'โอนสินค้าภายใน (GT)', url: 'https://inventory.pwcmall.in.th/form?type=internal&pick_type=internal&journal_id=11&action=out' },
      // { label: 'รับสินค้าภายใน (GT)', url: 'https://inventory.pwcmall.in.th/form?type=internal&pick_type=internal&journal_id=11&action=in' },
      // { label: 'รับสินค้า (GR-GBR)', url: 'https://inventory.pwcmall.in.th/inventory-list?type=in&journal_codes=GBR,GR&source_menu=inventory_gbr' },
      // { label: 'โอนสินค้าภายนอก (GBI)', url: 'https://inventory.pwcmall.in.th/inventory-list?type=out&journal_codes=GBS,GBI,GBJ&source_menu=inventory_gbi' },
      // { label: 'ปรับสต็อกเข้า (ADR)', url: 'https://inventory.pwcmall.in.th/form?type=inventory&pick_type=in&journal_id=100' },
      // { label: 'ปรับสต็อกออก (ADI)', url: 'https://inventory.pwcmall.in.th/form?type=inventory&pick_type=out&journal_id=101' },
      // { label: 'ร้องขอ (PQ)', url: 'https://inventory.pwcmall.in.th/form?type=inventory&pick_type=in&journal_id=37' },
      // { label: 'โอนของระหว่างสาขา (GBS)', url: 'https://inventory.pwcmall.in.th/form?type=inventory&pick_type=out&journal_id=86' },
      // { label: 'Inventory', url: 'https://inventory.pwcmall.in.th/inventory-list' },
      { label: 'นับสต็อก (Stock Count)', url: 'https://inventory.pwcmall.in.th/stock-count/history' },
      { label: 'แปรรูป (TIR)', url: 'https://inventory.pwcmall.in.th/transform' },
    ],

  },
  {
    title: 'อื่น ๆ',
    items: [
      { label: 'Probiz เก่า', url: 'https://report.pwcmall.in.th/#/dashboard' },
      { label: 'Internal', url: 'https://internal-new.pwcmall.in.th/product' },
      { label: 'เว็บไซต์บริษัท', url: 'https://pwc.pwcmall.in.th/' },
      { label: 'Bugmee HD', url: 'https://bugmee-hd.pwcmall.in.th/home' },
      { label: 'Customer', url: 'https://customer.pwcmall.in.th/#/home' },
      { label: 'Vendor', url: 'http://vendor.pwcmall.in.th'},
      // { label: 'POS ออนไลน์ : Buff Cafe', url: 'http://buffcafe.pwcmall.in.th/#/Probiz/authen' },
      { label: 'NF : Maruay', url: 'https://maruay.pwcmall.in.th/ui#name=login' },
      { label: 'NF : TRTC', url: 'https://trtc.pwcmall.in.th/ui#name=login' },
      { label: 'NF : Coffee', url: 'https://coffee.pwcmall.in.th/ui#name=login' },
      { label: 'NF : Green Energy', url: 'https://green-energy.pwcmall.in.th/ui#name=login' },
    ],
  },
]
